import React, { useRef, useState } from 'react';
import { Upload, Lock } from 'lucide-react';
import { ACCEPTED_EXTENSIONS } from './sncShared';

/**
 * The drop box shown before any file is in the check (the mock's upload card).
 * Onboarding offers "Skip this step"; a check reopened from Settings does not.
 */
export default function UploadCard({ mode, uploading, uploadError, busy, onFile, onSkip }) {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const isReopen = mode === 'reopen';
  const pick = () => {
    if (!uploading && inputRef.current) inputRef.current.click();
  };

  return (
    <section className="snc-card">
      <div className="snc-card__title-row">
        <h2>Sales Name Check</h2>
        {!isReopen && <span className="snc-optional">Optional</span>}
      </div>
      <p className="snc-card__subtitle">
        {isReopen
          ? 'Upload one month of POS sales. Names you already decided are remembered, so only new names come up.'
          : 'Upload one month of POS sales so every dish name is matched before you go live.'}
      </p>

      <div
        role="button"
        tabIndex={0}
        aria-disabled={uploading}
        className={`snc-dropzone${isDragging ? ' snc-dropzone--active' : ''}${uploading ? ' snc-dropzone--busy' : ''}`}
        onClick={pick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            pick();
          }
        }}
        onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);
          if (!uploading) onFile(e.dataTransfer?.files?.[0]);
        }}
      >
        <Upload size={26} className="snc-dropzone__icon" />
        <p className="snc-dropzone__title">
          {uploading ? 'Reading your file…' : 'Drop your one-month sales Excel sheet here'}
        </p>
        <p className="snc-dropzone__hint">or click to browse · .xlsx, .xls or .csv</p>
        <input
          ref={inputRef}
          type="file"
          accept={ACCEPTED_EXTENSIONS.join(',')}
          className="snc-file-input"
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            const file = e.target.files?.[0];
            e.target.value = '';
            onFile(file);
          }}
        />
      </div>
      {uploadError && <p className="snc-error" role="alert">{uploadError}</p>}

      {!isReopen && (
        <div className="snc-footer">
          <button type="button" className="snc-btn snc-btn--outline" onClick={onSkip} disabled={busy || uploading}>
            Skip this step
          </button>
          <div className="snc-footer__right">
            <span className="snc-footer__hint">Unlocks after Apply</span>
            <button type="button" className="snc-btn snc-btn--locked" disabled>
              <Lock size={13} /> Continue
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
